import { AiLoadingMessage } from './AiLoadingMessage';
import { type AiLoadingState } from './aiLoadingMessages.const';
export const AiGeneratingPending = ({
  imageSrc,
  prompt,
  loadingState
}: {
  imageSrc: string;
  prompt?: string;
  loadingState: AiLoadingState;
}) => {
  return <div className="flex size-full flex-col items-center justify-center gap-xl bg-gray-50 p-lg" data-sentry-component="AiGeneratingPending" data-sentry-source-file="Base.tsx">
      <img className="w-auto" src={imageSrc} alt="ai_generating" />
      <div className="flex w-full flex-col items-center gap-md">
        {prompt && <div className="line-clamp-2 w-full text-center text-heading-lg-extrabold text-gray-900">
            {prompt}
          </div>}
        <AiLoadingMessage state={loadingState} data-sentry-element="AiLoadingMessage" data-sentry-source-file="Base.tsx" />
      </div>
    </div>;
};